import classnames from "classnames";
import React, { MouseEvent, PropsWithChildren, useEffect } from "react";

import { useScrollLock } from "@utils/hooks/useScrollLock";

import "./overlay.scss";

type OverlayProps = PropsWithChildren<{
    isOpen: boolean;
    onClose: () => void;
    childrenInOverlay?: boolean;
    overlayHeader?: boolean;
    scrollLock?: boolean;
}>;

const OVERLAY_SCROLL_LOCK = "overlay";

const Overlay = ({
    isOpen,
    onClose,
    childrenInOverlay = true,
    children,
    overlayHeader = false,
    scrollLock = false,
}: OverlayProps) => {
    const handleOnNestedChildClick = (event: MouseEvent) => {
        event.stopPropagation();
    };

    const { lock, unlock } = useScrollLock(OVERLAY_SCROLL_LOCK);

    useEffect(() => {
        if (!scrollLock) return;

        (isOpen ? lock : unlock)();
    }, [isOpen]);

    const overlayComponent = (
        <div
            className={classnames(
                "overlay",
                isOpen && "overlay--open",
                overlayHeader && "overlay__header",
            )}
            onClick={onClose}
        >
            {isOpen && (
                <div onClick={handleOnNestedChildClick}>
                    {childrenInOverlay && children}
                </div>
            )}
        </div>
    );

    return (
        <>
            {overlayComponent}
            {!childrenInOverlay && children}
        </>
    );
};

export { Overlay };
